import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-modal" }
const _hoisted_2 = { class: "page-modal_header flex-row justify-end mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "page-modal_content" }

import { modalController } from "@ionic/vue";

import { getBrandImageUrl } from "@/js/brandImages";

interface PropsData {
  bgColor: "white" | "grey";
  visible: boolean;
  type?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PageModal',
  props: {
    bgColor: {},
    visible: { type: Boolean },
    type: {}
  },
  emits: ["onFinish"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function back() {
  if (props.type === "vocabularyTest") {
    emit("onFinish");
    return;
  }
  modalController.dismiss();
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "back cursor-pointer",
        src: _unref(getBrandImageUrl)('close_icon.png'),
        alt: "",
        onClick: back
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 512)), [
    [_vShow, props.visible]
  ])
}
}

})